// ═══════════════════════════════════════════════════════════════════════════════
// Direct multipart photo upload via backend (no GCS signed URLs)
// ═══════════════════════════════════════════════════════════════════════════════

import type { DirectFileUploadResponse } from '@fdh/shared';
import { getStoredToken } from './api';

const postImageFormOnce = async (path: string, formData: FormData): Promise<DirectFileUploadResponse> => {
  const token = getStoredToken();
  const response = await fetch(path, {
    method: 'POST',
    body: formData,
    credentials: 'include',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  const json = (await response.json()) as Record<string, unknown>;

  if (!response.ok) {
    const msg = typeof json.error === 'string' ? json.error : `HTTP ${response.status}`;
    throw new Error(msg);
  }

  if (json.success !== true || json.data === undefined || json.data === null) {
    throw new Error(typeof json.error === 'string' ? json.error : 'Upload failed');
  }

  return json.data as DirectFileUploadResponse;
};

export const uploadTaskPhotoViaBackend = async (blob: Blob, fileName: string): Promise<string> => {
  const fd = new FormData();
  fd.append('file', blob, fileName);
  const data = await postImageFormOnce('/api/task-instances/upload-photo', fd);
  const url = data.url?.trim() ?? '';
  if (url === '') {
    throw new Error('PHOTO_UPLOAD_FAILED');
  }
  return url;
};

export const uploadReceiptPhotoViaBackend = async (blob: Blob, fileName: string): Promise<string> => {
  const fd = new FormData();
  fd.append('file', blob, fileName);
  const data = await postImageFormOnce('/api/receipts/upload-photo', fd);
  const url = data.url?.trim() ?? '';
  if (url === '') {
    throw new Error('PHOTO_UPLOAD_FAILED');
  }
  return url;
};
